// extracted by mini-css-extract-plugin
module.exports = {"criteriaContainer":"_1htZkDWq","criteria":"_1HVC3Xyj","specificationHeader":"_78gnbg1z","specificationCore":"_3CCwW14m","pillboxContainer":"_3hz5xuIU","criteriaLabel":"bmDEwl2i"};